import axiosInstance from "../utils/axios-instance";

export const getIdleTimeDataService = async () => {
  const response = await axiosInstance.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/idle-time`
  );
  return response.data;
};

export const updateIdleTimeService = async (data: {
  idleTime: number;
  updatedBy: string;
}) => {
  const response = await axiosInstance.patch(
    `${process.env.REACT_APP_API_BASE_URL}/cms/idle-time`,
    data
  );
  return response.data;
};
